import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

const StaticBannersService = ({ banners }) => {
  const Router = useNavigate();
  const GoTo = (path) => {
    Router(path);
  };
  const getClassOfServiceBannerPartials = () => {
    switch (banners.length) {
      case 1:
        return 'full';
      case 2:
        return 'half';
      default:
        return '';
    }
  };
  return (
    <section className={`StaticBannersService-row ${getClassOfServiceBannerPartials()}`}>
      {banners.map((banner) => (
        <div className="StaticBannersService-col" key={banner.image}>
          <figure
            onClick={() => {
              GoTo(banner.link);
            }}
            className="StaticBannersService-figure"
          >
            <img
              src={banner.image}
              alt=""
            />
          </figure>
        </div>
      ))}
    </section>
  );
};


StaticBannersService.propTypes = {
  banners: PropTypes.array,
};

export default StaticBannersService;
